module.exports = __webpack_public_path__ + "img/exclamatoryMark.1c79f553.png";